import React from 'react';

import {useMediaQuery} from '../../hooks/useMediaQuery';
import {serviceMotionList} from '../../utils/serviceMotionList';

import FeatureCardBox from '../common/FeatureCardBox';

import {ReactComponent as DocumentExampleImg} from '../../assets/admin06/document-example.svg';
import {ReactComponent as DocumentImg} from '../../assets/admin06/document.svg';

export default function Admin05() {
    const mobileSmall = useMediaQuery('(max-width: 480px)');

    const dataMap = [
        { 
            type: 'document-example',
            title: '문서를 쉽게 관리하세요',
            subTitle: '학습 문서 업로드와 진행 상태를 편리하게 관리하세요',
            Image: DocumentExampleImg
        }
    ];

    return (
        <div>
            <FeatureCardBox
                type='admin-document'
                IconImage={DocumentImg}
                keyword='문서 관리'
                title={mobileSmall ? <>똑똑한 AI를 위한<br />문서 관리 시스템</> : '똑똑한 AI를 위한 문서 관리 시스템'}
                featureCardList={dataMap}
                titleMotion={serviceMotionList.titleMotion}
                cardMotion={serviceMotionList.cardMotion}
                motionVariant={serviceMotionList.admin04}
            />
        </div>
    );
}
